import { WorkspaceRoleKey } from 'hooks/internalApi';

import type { Option } from '@fragment/ui/src/components/Dropdown/Dropdown';

// Keyed on the role's string value so any generated `WorkspaceRoleKey` enum
// (internalApi, globalApi) can index it without a nominal-type mismatch.
export const workspaceRoleLabels: Record<string, string> = {
  [WorkspaceRoleKey.WorkspaceReader]: 'Reader',
  [WorkspaceRoleKey.WorkspaceAdmin]: 'Admin',
};

export const workspaceRoleOptions: Option[] = Object.entries(
  workspaceRoleLabels
).map(([value, label]) => ({ value, label }));
